import { FormattedMessage } from '@umijs/max';
import antdEnUS from 'antd/lib/locale/en_US';
import component from './en-US/component';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import register from './en-US/register';
import memberWelcome from './en-US/memberWelcome';
import staff from './en-US/staff';
import memberList from './en-US/memberList';
import dashboard from './en-US/dashboard';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.copyright.produced': 'Produced by Blue Ocean Tech Studio',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  
  // 403 page
  'pages.403.subTitle': 'Sorry, you are not authorized to access this page.',
  'pages.403.back': 'Back to home',
  
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...register,
  ...memberWelcome,
  ...staff,
  ...memberList,
  ...dashboard,
  'menu.account.logout': 'Logout',
  'menu.account.logout.confirm': 'Confirm Logout',
  'menu.account.logout.confirm.content': 'Are you sure you want to log out?',
  'menu.account.logout.success': 'Successfully logged out',
  'menu.account.logout.failed': 'Logout failed',
  
  'menu.account.changePassword': 'Change Password',
  'menu.account.changePassword.currentPassword': 'Current Password',
  'menu.account.changePassword.currentPassword.required': 'Please enter current password',
  'menu.account.changePassword.newPassword': 'New Password',
  'menu.account.changePassword.newPassword.required': 'Please enter new password',
  'menu.account.changePassword.password.tooShort': 'Password must be at least 6 characters',
  'menu.account.changePassword.confirmPassword': 'Confirm Password',
  'menu.account.changePassword.confirmPassword.required': 'Please confirm your new password',
  'menu.account.changePassword.passwordMismatch': 'The two passwords do not match',
  'menu.account.changePassword.success': 'Password changed successfully',
  'menu.account.changePassword.failed': 'Failed to change password',
  'menu.account.changePassword.incorrectPassword': 'Current password is incorrect',
  'pages.memberList.pagination.total': 'Total {total} items',
  'pages.memberList.pagination.pageSize': 'items/page',
  'pages.memberList.pagination.jump': 'Jump to',
  'pages.memberList.pagination.page': 'page',
  
  // Gift Card List
  'pages.giftCardList.title': 'Gift Card List',
  'pages.giftCardList.create': 'Create Gift Card',
  'pages.giftCardList.createVirtual': 'Create Virtual Gift Card',
  'pages.giftCardList.createPhysical': 'Create Physical Gift Card',
  'pages.giftCardList.downloadPhysical': 'Download Physical Card Numbers',
  'pages.giftCardList.code': 'Card Number',
  'pages.giftCardList.physicalCardNumber': 'Physical Card Number',
  'pages.giftCardList.value': 'Value',
  'pages.giftCardList.initialAmount': 'Initial Amount',
  'pages.giftCardList.balance': 'Balance',
  'pages.giftCardList.balanceStatus': 'Balance',
  'pages.giftCardList.balanceStatus.all': 'All gift cards',
  'pages.giftCardList.balanceStatus.withBalance': 'With balance',
  'pages.giftCardList.balanceStatus.withoutBalance': 'Without balance',
  'pages.giftCardList.status': 'Status',
  'pages.giftCardList.createTime': 'Create Time',
  'pages.giftCardList.activeDate': 'Active Date',
  'pages.giftCardList.activeBy': 'Active By',
  'pages.giftCardList.activationStatus': 'Activation Status',
  'pages.giftCardList.activationStatus.all': 'All gift cards',
  'pages.giftCardList.activationStatus.active': 'Activated',
  'pages.giftCardList.activationStatus.inactive': 'Inactive',
  'pages.giftCardList.expiryDate': 'Expiry Date',
  'pages.giftCardList.validDays': 'Validity (Days)',
  'pages.giftCardList.actions': 'Actions',
  'pages.giftCardList.actions.details': 'Details',
  'pages.giftCardList.note': 'Note',
  'pages.giftCardList.date': 'Date Range',
  'pages.giftCardList.refresh': 'Refresh',
  'pages.giftCardList.email': 'Email',
  'pages.giftCardList.phone': 'Phone',
  'pages.giftCardList.tempEmail': 'Temporary Email',
  'pages.giftCardList.tempPhone': 'Temporary Phone',
  'pages.giftCardList.contactInfo': 'Contact Type',
  'pages.giftCardList.search.infoType.placeholder': 'Select contact type',
  'pages.giftCardList.contactValue': 'Contact Value',
  'pages.giftCardList.search.infoValue.placeholder': 'Enter contact information',
  'pages.giftCardList.createDate': 'Create Date',
  
  'pages.giftCardList.search.code.placeholder': 'Enter card number',
  'pages.giftCardList.search.cardNumber': 'Card ID / Physical Card Number',
  'pages.giftCardList.search.status.placeholder': 'Select status',
  'pages.giftCardList.search.date.start': 'Start date',
  'pages.giftCardList.search.date.end': 'End date',
  'pages.giftCardList.search.submit': 'Search',
  'pages.giftCardList.search.reset': 'Reset',
  
  'pages.giftCardList.create.success': 'Gift card created successfully',
  'pages.giftCardList.create.error': 'Gift card creation failed',
  'pages.giftCardList.create.value.required': 'Please enter gift card value',
  'pages.giftCardList.create.value.placeholder': 'Please enter gift card value',
  'pages.giftCardList.create.balance.required': 'Please enter initial balance',
  'pages.giftCardList.create.balance.placeholder': 'Please enter initial balance',
  'pages.giftCardList.create.initialAmount.required': 'Please enter the initial amount',
  'pages.giftCardList.create.initialAmount.placeholder': 'Please enter the initial amount',
  'pages.giftCardList.create.email.placeholder': 'Please enter email',
  'pages.giftCardList.create.phone.placeholder': 'Please enter phone number',
  'pages.giftCardList.create.expiryDate.placeholder': 'Please select expiry date',
  'pages.giftCardList.create.validDays.required': 'Please enter the validity in days',
  'pages.giftCardList.create.validDays.placeholder': 'Please enter the number of valid days',
  'pages.giftCardList.create.note.placeholder': 'Please enter note',
  'pages.giftCardList.physical.issuingStore': 'Issuing Store',
  'pages.giftCardList.physical.storeRequired': 'Please select an Issuing Store',
  'pages.giftCardList.physical.quantity': 'Quantity',
  'pages.giftCardList.physical.batch': 'Creation Batch',
  'pages.giftCardList.physical.allBatches': 'All Physical Gift Cards',
  'pages.giftCardList.physical.loadError': 'Failed to load Physical Gift Card options',
  'pages.giftCardList.physical.createSuccess': 'Created {count} Physical Gift Cards',
  'pages.giftCardList.physical.createError': 'Failed to create Physical Gift Cards',
  'pages.giftCardList.physical.batchLoadError': 'Failed to load Physical Gift Card batches',
  'pages.giftCardList.physical.downloadError': 'Failed to download Physical Card Numbers',
  
  'pages.giftCardList.level': 'Gift Card Type',
  'pages.giftCardList.create.level.required': 'Please select gift card type',
  'pages.giftCardList.create.level.placeholder': 'Please select gift card type',
  'pages.giftCardList.error.headOffice': 'Failed to get head office information',
  'pages.giftCardList.error.fetchLevels': 'Failed to fetch gift card types',
  'pages.giftCardList.error.storeId': 'Store ID not found',
  'pages.giftCardList.error.invalidStoreId': 'Invalid store ID format',
  'pages.giftCardList.error.fetchFailed': 'Failed to fetch gift card list',
  'pages.giftCardList.error.fetchStoreFailed': 'Failed to fetch store information',
  'pages.giftCardList.error.noLevels': 'No gift card types found. Please create gift card types in the admin panel first',
  
  'pages.giftCardList.status.active': 'Active',
  'pages.giftCardList.status.inactive': 'Inactive',
  'pages.giftCardList.status.expired': 'Expired',
  'pages.giftCardList.status.used': 'Used',
  'pages.giftCardList.status.cancelled': 'Cancelled',
  
  'pages.giftCardList.pagination.total': 'Total {total} items',
  'pages.giftCardList.pagination.pageSize': 'items/page',
  'pages.giftCardList.pagination.jump': 'Jump to',
  'pages.giftCardList.pagination.page': 'page',
  
  'app.common.cancel': 'Cancel',
  'app.common.create': 'Create',
  'pages.store.giftCardDetails.send.email': 'Send Email',
  'pages.store.giftCardDetails.send.phone': 'Send SMS',
  'pages.store.giftCardDetails.send.card': 'Send Card',
  'pages.store.giftCardDetails.send.wallet': 'Add to Wallet',
  'pages.store.giftCardDetails.email.placeholder': 'Enter email',
  'pages.store.giftCardDetails.phone.placeholder': 'Enter phone number',

};
